import { takeLatest } from 'redux-saga/effects'
import request from 'services/Request'
import * as requestActionTypes from 'services/Request/actionTypes'
import * as locationActionTypes from 'services/Location/actionTypes'
import * as actionTypes from '../actionTypes'
import * as api from '../api'
import prepareSearchArgs from '../searchStoreHelper'

export const isGeoCoordinatesChange = (action: ActionType) =>
  action.type === requestActionTypes.SUCCEEDED &&
  action.meta.sourceType === locationActionTypes.GEO_REQUESTED

export function* searchResult(): Generator {
  const args = yield prepareSearchArgs()
  yield request(actionTypes.SEARCH_REQUESTED, api.getStoreList, args)
}

export function* getListSaga() {
  yield takeLatest(
    [
      isGeoCoordinatesChange, // Geo coordinates updated
      locationActionTypes.GEO_UPDATED, // Geo coordinates updated
      actionTypes.SEARCH_REQUESTED,
      actionTypes.AREA_UPDATED,
      actionTypes.FILTERS_UPDATED,
      actionTypes.FILTERS_CLEARED,
    ],
    searchResult,
  )
}

export default getListSaga
